import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { RuleListStatus } from '@wix/rules-panel-ui';
import { assertNotOptional } from '@wix/seo-common-core';
import { AnalysisState } from '../../hooks/rules-state';
export function hasFailedRulesInGroupExcept(groupData, excludedRuleId) {
  const {
    rulesStateMap
  } = groupData;
  assertNotOptional(rulesStateMap, 'rulesStateMap');
  return [...rulesStateMap.values()].some(ruleState => {
    var _ruleState$state;
    return (ruleState == null ? void 0 : ruleState.ruleId) !== excludedRuleId && (ruleState == null || (_ruleState$state = ruleState.state) == null ? void 0 : _ruleState$state.status) === RuleListStatus.failed;
  });
}
export const getNumberOfIssuesInGroup = rulesStateMap => {
  return Array.from(rulesStateMap.values()).filter(ruleStatus => {
    var _ruleStatus$state;
    return (ruleStatus == null || (_ruleStatus$state = ruleStatus.state) == null ? void 0 : _ruleStatus$state.status) === RuleListStatus.failed;
  }).length;
};
export const getNumberOfIssuesInVerticalGroup = (panelState, itemType) => {
  const groupsData = panelState.groupsDataMap;
  let issuesCount = 0;
  for (const group of groupsData.values()) {
    if (group.itemType !== itemType) {
      continue;
    }
    for (const ruleState of group.rulesStateMap.values()) {
      var _ruleState$state2;
      if ((ruleState == null || (_ruleState$state2 = ruleState.state) == null ? void 0 : _ruleState$state2.status) === RuleListStatus.failed) {
        issuesCount++;
      }
    }
  }
  return issuesCount;
};
export const isStaticPage = itemType => itemType ? itemType === ITEM_TYPES.STATIC_PAGE_V2 : false;

/**
 * Determines if a rule's status should be updated due to global section changes.
 * 
 * When global sections (header, footer, etc.) are modified, their status
 * can affect multiple pages. This function checks if we should propagate those changes
 * to update the rule status on the current page.

 * Conditions for update:
 * - Analysis is complete and results are ready
 * - UI status differs from stored status (indicating global section changes affected this rule)
 * - We're dealing with a static page (routerId === undefined ensures this is a static page)
 */
export const shouldUpdateRuleStatus = (analysisState, uiStatus, ruleState, routerId) => {
  var _ruleState$state3;
  return analysisState === AnalysisState.AnalyzeDoneResultsReady && uiStatus !== (ruleState == null || (_ruleState$state3 = ruleState.state) == null ? void 0 : _ruleState$state3.status) && routerId === undefined;
};
//# sourceMappingURL=helpers.js.map